import { frontApiUrl } from '../../../../core/Api/Front/url';
import { Locale } from '../../../../core/i18n/Locale';
import {
    FetchItinerariesFilter,
    FetchItinerariesSort,
    ItineraryFromAPI,
} from '../../../../pages/api/front/itineraries';
import { generateUrl } from '../../../../shared/utilities/routing/routing';
import { handleResponse } from '../../../shared/types/handlers';

async function fetchItineraries({
    locale,
    page,
    perPage,
    filters,
    sort,
}: {
    locale: Locale;
    page: number;
    perPage: number;
    filters: FetchItinerariesFilter[];
    sort?: FetchItinerariesSort;
}) {
    const response = await fetch(
        frontApiUrl(
            generateUrl('api_itineraries', locale, {
                locale,
                page,
                perPage,
                filters: JSON.stringify(filters),
                ...(sort ? { [`sorts[${sort.key}]`]: sort.value } : {}),
            }),
        ),
    );

    return handleResponse<ItineraryFromAPI>(response);
}

export async function getItineraries({
    locale,
    page,
    perPage,
    filters,
    sort,
}: {
    locale: Locale;
    page: number;
    perPage: number;
    filters: FetchItinerariesFilter[];
    sort?: FetchItinerariesSort;
}): Promise<ItineraryFromAPI> {
    return fetchItineraries({
        locale,
        page,
        perPage,
        filters,
        sort,
    });
}
